import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { testMistralAPI, testOpenAIAPI } from "@/services/apiTester";
import { TestResult } from "./TestResult";
import { supabase } from "@/integrations/supabase/client";

export const AIKeyTester = () => {
  const [selectedAI, setSelectedAI] = useState<string>("");
  const [apiKey, setApiKey] = useState("");
  const [testResult, setTestResult] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const logError = async (error: string) => {
    try {
      await supabase.from('monitoring_logs').insert([
        {
          type: 'error',
          description: `Erro no teste de API ${selectedAI}: ${error}`
        }
      ]);
    } catch (err) {
      console.error('Erro ao registrar log:', err);
    }
  };

  const testKey = async () => {
    setIsLoading(true);
    setTestResult(null);
    
    try {
      const result = await (selectedAI === "mistral" 
        ? testMistralAPI(apiKey)
        : testOpenAIAPI(apiKey));
      
      setTestResult(result);

      // Se o teste falhou, registrar o erro
      if (!result.includes("válida")) {
        await logError(result);
      }
    } catch (error: any) {
      const errorMessage = error.message || 'Erro desconhecido';
      setTestResult(errorMessage);
      await logError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const isSuccess = testResult?.includes("válida") && !testResult?.includes("inválida");

  return (
    <Card>
      <CardContent className="pt-6 space-y-4">
        <div className="space-y-2">
          <label className="text-sm font-medium">Selecionar IA</label>
          <Select value={selectedAI} onValueChange={setSelectedAI}>
            <SelectTrigger>
              <SelectValue placeholder="Escolha a IA para testar" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="mistral">Mistral AI</SelectItem>
              <SelectItem value="openai">OpenAI (ChatGPT)</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium">Chave API</label>
          <Input
            type="password"
            placeholder="Digite a chave API para testar"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
          />
        </div>

        <Button
          onClick={testKey}
          disabled={!selectedAI || !apiKey || isLoading}
          className="w-full"
        >
          {isLoading ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Testando...
            </>
          ) : (
            "Testar Chave"
          )}
        </Button>

        <TestResult result={testResult} isSuccess={isSuccess} />
      </CardContent>
    </Card>
  );
};